"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  QuickHelp: true
};
exports.default = exports.QuickHelp = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Button = require("../Buttons/Button");
var _Icon = require("../Icon/Icon");
var _constants = require("../utils/constants");
var _PopoverBase = _interopRequireDefault(require("./_PopoverBase"));
var _QuickHelp = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./QuickHelp.css") : void 0);
var _QuickHelp2 = require("./QuickHelp.types");
Object.keys(_QuickHelp2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _QuickHelp2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _QuickHelp2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-quick-help';
/**
 * **QuickHelp** components are specialized **Popover** components attached to “?” icons.
 * Unlike **Popover** components, **QuickHelp** components display text, not arbitrary content.
 */
const QuickHelp = _props => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(QuickHelp, _props)) : _props;
  const {
      iconProps,
      message,
      textClose,
      textShowQuickHelp,
      title,
      placement = ['bottom', 'top', 'left', 'right'],
      popoverProps,
      innerProps
    } = props,
    otherProps = __rest(props, ["iconProps", "message", "textClose", "textShowQuickHelp", "title", "placement", "popoverProps", "innerProps"]);
  const classnames = _bind.default.bind(_QuickHelp.default);
  const classes = classnames(_constants.CSS_PREFIX, CSS_BLOCK, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className);
  const iconPath1Classes = classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__icon-path1`);
  const targetClassName = classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__target`);
  return /*#__PURE__*/_react.default.createElement(_PopoverBase.default, Object.assign({
    placement: placement
  }, popoverProps, {
    message: message,
    targetClassName: targetClassName,
    textClose: textClose,
    title: title
  }), /*#__PURE__*/_react.default.createElement(_Button.Button, Object.assign({}, otherProps, {
    "aria-label": textShowQuickHelp,
    type: "link",
    compact: true,
    innerProps: Object.assign(Object.assign({}, innerProps), {
      className: classes
    })
  }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, Object.assign({
    iconName: "messaging-help"
  }, iconProps, {
    ariaHidden: true,
    path1ClassName: iconPath1Classes
  }))));
};
exports.QuickHelp = QuickHelp;
QuickHelp.displayName = 'QuickHelp';
var _default = exports.default = QuickHelp;